module.exports = __webpack_public_path__ + "img/new-password.674cdcea.svg";